import { SELECTED_LANGUAGE_LOCALSTORAGE_KEY, SETTINGS_LOCAL_STORAGE_KEY } from './constants';
import { storageFactory } from '../Storage';

export const getPreviouslyStoredLanguage = (): string | undefined => localStorage.getItem(SELECTED_LANGUAGE_LOCALSTORAGE_KEY);

export const settingsStorage = storageFactory(SETTINGS_LOCAL_STORAGE_KEY);